import { Container } from "@mui/material";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs";
import { useSettingsContext } from "src/components/settings";
import { paths } from "src/routes/paths";
import { useRanking } from "../hooks/use-ranking";
import { useConfetti } from "../hooks/use-confetti";
import RankingContent from "./ranking-content";

// ----------------------------------------------------------------------

export default function RankingView() {
  const settings = useSettingsContext();
  const { rankedSellers, rankedPositions, loading } = useRanking();

  // Confetes - SOMENTE na URL "/dashboard/ranking"
  useConfetti(500);

  return (
    <Container maxWidth={settings.themeStretch ? false : "lg"}>
      <CustomBreadcrumbs
        heading="🏆 Ranking de Operadores"
        links={[
          { name: "Mercado" },
          { name: "Operadores", href: paths.dashboard.sellers.root },
          { name: "Ranking" },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <RankingContent
        rankedSellers={rankedSellers}
        rankedPositions={rankedPositions}
        loading={loading}
        maxWidth={settings.themeStretch ? false : "lg"}
      />
    </Container>
  );
}
